var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 19H9.414L23.057 5.35701C23.6414 4.77118 23.9696 3.97749 23.9696 3.15001C23.9696 2.32254 23.6414 1.52884 23.057 0.943012C22.4627 0.374905 21.6722 0.0578613 20.85 0.0578613C20.0278 0.0578613 19.2373 0.374905 18.643 0.943012L5 14.586V19ZM7 15.414L20.057 2.35701C20.2706 2.15297 20.5546 2.0391 20.85 2.0391C21.1454 2.0391 21.4294 2.15297 21.643 2.35701C21.8529 2.56753 21.9708 2.8527 21.9708 3.15001C21.9708 3.44732 21.8529 3.7325 21.643 3.94301L8.586 17H7V15.414Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.621 7.622L22 9.243V16H16V22H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H14.758L16.379 0.379C16.525 0.243624 16.6789 0.117066 16.84 0L3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3L0 24H18.414L24 18.414V7.161C23.8827 7.32186 23.7561 7.47579 23.621 7.622ZM18 21.586V18H21.586L18 21.586Z",
    fill: "#2D2D2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8d98eab4c122540f33aa9467b5b8e79b.svg";
export { ForwardRef as ReactComponent };